import { h } from 'preact';

const ComingSoon = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
			<path fill-opacity=".3" d="M8.555 14H3c-.551 0-1-.449-1-1V7h12v1.555c.378.22.714.497 1 .825V4a2 2 0 0 0-2-2h-1v-.5a.5.5 0 0 0-1 0V2H5v-.5a.5.5 0 0 0-1 0V2H3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h6.38a3.976 3.976 0 0 1-.825-1zM2 4c0-.551.449-1 1-1h1v.5a.5.5 0 0 0 1 0V3h6v.5a.5.5 0 0 0 1 0V3h1c.551 0 1 .449 1 1v2H2V4z" />
			<path d="M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 .5a.5.5 0 0 1 .5.5v1.5h1a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5z" />
		</svg>
	);
};

export default ComingSoon;